export default {
    'terms_of_service': 'Terms of Service',
    'client': 'Client Licence',
    'eula': 'EULA',
    'contributions': 'Contribution Rules',
    'reasonable_use': 'Conditions of Reasonable Use'
};